import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'partnerhub';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { concatMap, map, pluck } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Offer, Product, ProductCreate, ProductDependency } from '../../models';
import { OfferChannels } from '../../models/product/offer-channels.model';
import { OfferLoyalty } from '../../models/product/offer-loyalty.model';
import { OfferTributes } from '../../models/product/offer-tributes.model';
import { ProductKeywords } from '../../models/product/product-keywords.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {

  public baseURL = environment.serverApiBaseUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly helperService: HelperService,
    private readonly datePipe: DatePipe,
    private readonly translateService: TranslateService,
  ) { }

  private currentKeywordsData = new BehaviorSubject<ProductKeywords>(null)
  private currentChannelsData = new BehaviorSubject<OfferChannels>(null)
  private currentOfferSate = new BehaviorSubject<string>(null)
  private currentProduct = new BehaviorSubject<Product>(null)
  private tabsSource = new BehaviorSubject([]);
  tabsToDisplay = this.tabsSource.asObservable();

  private msgDTOList =
  {
    mtsProduct: [
      {
        msgAction: 'USER_DEACTIVATED_BLACKLIST', //P
        msgValue: ''
      },
      {
        msgAction: 'BLACKLIST_ERROR',//P
        msgValue: ''
      },
      {
        msgAction: 'USER_ACTIVATED_BLACKLIST',//P
        msgValue: ''
      },
      {
        msgAction: 'OPTOUT_NO_SUB',//P
        msgValue: ''
      },
      {
        msgAction: 'MSG_KEYWORD_NOT_FOUND',//P
        msgValue: ''
      },
      {
        msgAction: 'MSG_KEYWORD_NOT_FOUND_PREACTIVE',//P
        msgValue: ''
      },
      {
        msgAction: 'MSG_KEYWORD_NOT_FOUND_ACTIVE',//P
        msgValue: ''
      },
      {
        msgAction: 'USER_ALREADY_BLACKLISTED',//P
        msgValue: ''
      },
      {
        msgAction: 'USER_ALREADY_WHITELISTED',//P
        msgValue: ''
      },
      {
        msgAction: 'SUB_ALREADY_OUT',//P
        msgValue: ''
      },
      {
        msgAction: 'SUC_PAYMENT',
        msgValue: ''
      },
      {
        msgAction: 'FAIL_PAYMENT',
        msgValue: ''
      },
      {
        msgAction: 'UNAVAILABLE_SERVICE',
        msgValue: ''
      },
      {
        msgAction: 'SERVICE_NOT_SUBSCRIBED',
        msgValue: ''
      },
      {
        msgAction: 'ALREADY_IN',
        msgValue: ''
      },
      {
        msgAction: 'FAIL_SUB_NO_BALANCE',
        msgValue: ''
      },
      {
        msgAction: 'NOT_ELIGIBLE',
        msgValue: ''
      },
      {
        msgAction: 'USER_IS_IN_BLACKLIST',
        msgValue: ''
      },
      {
        msgAction: 'HELP',
        msgValue: ''
      },
    ],
    mtsOffer: [
      {
        msgAction: 'SUB_OPTIN_FREE_PERIOD',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTIN_CHARGE_OK',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTOUT',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL_FAILED',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTIN_STEP_DOWN',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTIN_STEP_DOWN_AUTOMATIC',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL_STEP_DOWN',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL_STEP_DOWN_AUTOMATIC',
        msgValue: ''
      },
      {
        msgAction: 'SUSPENDED_OPTIN',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL_SUSPENDED_CHARGE_NOT_OK',
        msgValue: ''
      },
      {
        msgAction: 'SUB_RENEWAL_SUSPENDED_CHARGE_OK',
        msgValue: ''
      },
      {
        msgAction: 'SUB_REPLACE',
        msgValue: ''
      },
      {
        msgAction: 'REPLACE_CHARGE_GENERIC_ERROR',
        msgValue: ''
      },
      {
        msgAction: 'REPLACE_SUB_ERROR',
        msgValue: ''
      },
      {
        msgAction: 'REMINDER_AFTER_FREE_PERIOD',
        msgValue: '{{PRODUCT_NAME}}: Faltam {{DELTA_HOURS}} dias para terminar sua gratuidade. Apos o periodo de gratuidade, RS {{RENEW_PRICE}} por {{PRODUCT_RENEW_PERIOD}} dias. Cancelar? Envie SAIR.'
      },
      {
        msgAction: 'REMINDER_AFTER_TRIAL_PERIOD',
        msgValue: ''
      },
      {
        msgAction: 'GET_USER_INFO_ERROR',
        msgValue: ''
      },
      {
        msgAction: 'NO_BALANCE',
        msgValue: ''
      },
      {
        msgAction: 'OPTOUT_NO_SUB',
        msgValue: ''
      },
      {
        msgAction: 'OFFER_SUBSCRIPTION_CANT_COEXIST',
        msgValue: ''
      },
      {
        msgAction: 'SUB_PRE_OPTIN',
        msgValue: '{{PRODUCT_NAME}}: assinatura confirmada por R$ {{SUB_PRICE_VALUE}} por semana com renovacao automatica. Duvidas? Envie AJUDA. Cancelar? Envie SAIR'
      },
      {
        msgAction: 'OPTIN_REJECT',
        msgValue: ''
      },
      {
        msgAction: 'ONTOPOF_SUB_PRE_OPTIN',
        msgValue: '{{PRODUCT_NAME}}: Para confirmar a assinatura do servico por R$ {{SUB_PRICE_VALUE}}, responda SIM por mes com renovacao automatica e com cobranca direto em sua conta'
      },
      {
        msgAction: 'DISCOUNT_APPLIED_MT',
        msgValue: ''
      },
      {
        msgAction: 'DISCOUNT_OPTOUT_MT',
        msgValue: ''
      },
      {
        msgAction: 'DOUBLE_OPTIN_TIMEOUT',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTIN_TRIAL_PERIOD',
        msgValue: ''
      },
      {
        msgAction: 'EXCHANGE_BUNDLE_PRODUCT_FAILED',
        msgValue: ''
      },
      {
        msgAction: 'EXCHANGE_BUNDLE_PRODUCTS',
        msgValue: ''
      },
      {
        msgAction: 'CHANGE_TITULARITY',
        msgValue: ''
      },
      {
        msgAction: 'REMINDER_AFTER_TRIAL_PERIOD reminderAfterTrialPeriod',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTOUT_WITH_PENALTY',
        msgValue: ''
      },
      {
        msgAction: 'SUB_OPTOUT_WITHOUT_PENALTY',
        msgValue: ''
      },
      {
        msgAction: 'reminderTastingTemplate',
        msgValue: '{{PRODUCT_NAME}}: Atenção! R$ {{SUB_PRICE_VALUE}} após {{NUM_MESES_GRATUIDADE}} meses de gratuidade'
      }
    ]
  }

  public getPlanChangeOfferIdList(productId, offerId = null): any {
    console.log('productId:', productId);
    const params = `productId=${productId}` + (offerId ? `&offerId=${offerId}` : '');
    const url = `/${this.baseURL}/offer/offersList?${params}`;
    return this.http.get(url);
  }

  public getCclasTribList(): any {
    const url = `/${this.baseURL}/offer/taxCodesList`;
    return this.http.get(url).pipe(pluck('cclasTribList'));
  }
  
  public getInvoiceFieldsOptionsList(): any {
    const url = `/${this.baseURL}/offer/taxCodesList`;
    return this.http.get(url);
  }

  public changeTabs(tabs) {
    setTimeout(() => {
      this.tabsSource.next(tabs);
    }, 0);
  }

  public getMsgDTOList(): {mtsProduct: any[], mtsOffer: any[]}{
    return this.msgDTOList
  }

  public resetTabs() {
    setTimeout(() => {
      this.tabsSource.next([]);
    }, 0);
  }

  private getCostModels(costModels): any[] {
    costModels.forEach((element, index) => {
      costModels[index].event = element.event.name;
      costModels[index].revenueModel = element.revenueModel.name;
    });
    return costModels;
  }

  //Public methods to work with current values
  public setCurrentChannelsData(channelsData: OfferChannels){
    this.currentChannelsData.next(channelsData)
  }

  public getCurrentChannelsData(): Observable<OfferChannels>{
    return this.currentChannelsData
  }

  public setCurrentKeywordsData(keywordsData: ProductKeywords){
    this.currentKeywordsData.next(keywordsData)
  }

  public getCurrentKeywordsData(): Observable<ProductKeywords>{
    return this.currentKeywordsData
  }

  public setCurrentOfferState(offerState: string){
    this.currentOfferSate.next(offerState)
  }

  public getCurrentOfferState(): Observable<string>{
    return this.currentOfferSate
  }

  public setCurrentProduct(product: Product){
    this.currentProduct.next(product)
  }

  public getCurrentProduct(): Observable<Product>{
    return this.currentProduct
  }

  public getUserBasicProfileOptions() : any {

    return [
      { id: 'Limited', name: "Limited" },
      { id: 'Very_Limited', name: "Very Limited" },
      { id: 'UserContext', name: "UserContext" },
      { id: 'Full', name: "Full" },
      { id: 'Basic', name: "Basic" },
    ];
  }

  public isShortcodeAvailable(shortcode: string): Observable<{ available: boolean; alphaTag: string}> {
    if(!shortcode){
      return throwError(this.translateService.instant('genericErrorMessages.shortcodeRequired'));
    }
    let params = new HttpParams().append('shortcode', shortcode);
    const url = `/${this.baseURL}/product/isShortcodeAvailable`;
    return this.http.get<{ available: boolean; alphaTag: string}>(url, { params });
  }

  public createProduct(product: ProductCreate, file): Observable<Product> {
    const url = `/${this.baseURL}/product-requests`;

    const body: Product = {
      name: product.productDetails.productName,
      partnerId: product.productDetails.partner.entityId,
      resourceType: product.productDetails.productType,
      contentType: product.productDetails.productMainCategory,
      banner: null, // TODO: Wrong object?
      description: product.productDetails.description,
      country: product.countryOperator.country,
      offers: product.offers.map((offer) => {
        return {
          name: offer.details.offerName,
          type: offer.details.offerType,
          frequency: offer.details.periods,
          channels: offer.communication ? offer.communication.entryChannels : null,
          landingPage: offer.communication ? offer.communication.inapp.landingPage || null : null,
          productDescription: offer.communication ? offer.communication.inapp.productDescritpion || null : null,
          template: offer.communication
            ? offer.communication.inapp.template
              ? offer.communication.inapp.template.id
              : null
            : null,
          languages: offer.details.languages,
          keywords: offer.communication
            ? [
              {
                /** TODO: Keywords need enlightment */
                type: 'SUBSCRIBE',
                regex: offer.communication.sms.activationKeyword,
                value: offer.communication.sms.activationKeyword,
              },
            ]
            : null,
          priceModel: {
            activationPrice: {
              value: offer.details.activationPrice,
            },
            renewalPrice: offer.details.renewalPrice
              ? {
                value: offer.details.renewalPrice,
              }
              : null,
            freePeriod: offer.details.billingDelayPeriod ? offer.details.billingDelayPeriod : null,
          },
          // costModels: this.getCostModels(offer.costModels),
          messages: offer.communication
            ? [
              {
                type: 'SUB_OPTIN',
                content: offer.communication.welcomeMessage,
              },
              {
                type: 'BILLING',
                content: offer.communication.billingMessage,
              },
              {
                type: 'HELP',
                content: offer.communication.helpMessage,
              },
              {
                type: 'SUB_PRE_OPTIN',
                content: offer.communication.doubleOptMessage,
              },
              {
                type: 'MSG_BLACKLISTED',
                content: offer.communication.blacklistMessage,
              },
              {
                type: 'REFUND',
                content: offer.communication.refundMessage,
              },
            ]
            : null, 
            notificationUrl: offer.communication ? offer.communication.notificationUrl : null,
            period: offer.details.periods ? {
              type: offer.details.periods.name,
              value: offer.details.advancedPeriod,
            } : null,
              shortCodes: offer.communication ? [ /** TODO: Short Code needs enlightment */
                {
                  shortcode: offer.communication.sms.shortcodes.value,
                  alphaTag: offer.communication.sms.alphaTag?.value,
                },
              ] : null,
        };
      }),
    };
    return this.http.post<Product>(url, body);
  }

  public getConfigsNotificationProductId(productId: number): Observable<any> {
    const url = `/${this.baseURL}/product/${productId}/configuration/notification`;
    return this.http.get<Offer[]>(url);
  }

  public getConfigsSlaProductId(productId: number): Observable<any> {
    const url = `/${this.baseURL}/product/${productId}/configuration/sla`;
    return this.http.get<Offer[]>(url);
  }

  public getConfigsCommunicationsKeywordsProductId(productId: number): Observable<any> {
    const url = `/${this.baseURL}/product/${productId}/configuration/communication/keyword`;
    return this.http.get<ProductKeywords>(url);
  }

  public getConfigsCommunicationsMTsProductId(productId: number): Observable<any> {
    const url = `/${this.baseURL}/product/${productId}/configuration/communication/mts`;
    return this.http.get<Offer[]>(url);
  }

  public getProductsTypes(): Observable<String[]> {
    const url = `/${this.baseURL}/product/type`;
    return this.http.get<String[]>(url);
  }

  public getOfferDetailsById(offerId: number): Observable<Offer> {
    const url = `/${this.baseURL}/offer/${offerId}`;
    return this.http.get<Offer>(url);
  }

  public getUniqueEligibility(type?: string): Observable<any> {
    let myParams = new HttpParams();
    if (type) {
      myParams = myParams.append('type', type)
    }
    const url = `/${this.baseURL}/offer/listAllUniqueEligibility`;
    return this.http.get<any>(url, {params: myParams});
  }

  public getCategoryList(): Observable<any> {
    const url = `/${this.baseURL}/category`;
    return this.http.get<any>(url);
  }

  public getOfferStatus(offerId: number): Observable<{comments: string, offerStatus: string}> {
    const url = `/${this.baseURL}/offer/${offerId}/status`;
    return this.http.get<{comments: string, offerStatus: string}>(url);
  }

  public getOfferLoyalty(offerId: number): Observable<OfferLoyalty> {
    const url = `/${this.baseURL}/offer/${offerId}/loyalty`;
    return this.http.get<OfferLoyalty>(url);
  }

  public getOfferEmailsPrmNotification(offerId: number): Observable<any> {
    const url = `/${this.baseURL}/offer/${offerId}/prm-notification`;
    return this.http.get<any>(url);
  }

  public updateOfferEmailsPrmNotification(id, formValues): any {
    console.log('formValues:', formValues);
    const obj = {
      subscriptionText: formValues.formData.subscriptionText,
      discountText: formValues.formData.discountText,
      loyaltyText: formValues.formData.loyaltyText,
      cancelationText: formValues.formData.cancelationText,
      preCancelationText: formValues.formData.preCancelationText,
      voucherText: formValues.formData.voucherText,
      svaLinkApp: formValues.formData.svaLinkApp,
      svaFreeLinkApp: formValues.formData.svaFreeLinkApp,
      doubleOptinLinkApp: formValues.formData.doubleOptinLinkApp,
      emailFixaFree: formValues.formData.emailFixaFree,
      reminderOffer: formValues.formData.reminderOffer,
      svaActivationFreePeriod: formValues.formData.svaActivationFreePeriod,
      isServiceName: formValues.formData.isServiceName.id == "ServiceName" ? true : false,
      cancelationWithPenaltyText: formValues.formData.cancelationWithPenaltyText,
      cancelationWithoutPenaltyText: formValues.formData.cancelationWithoutPenaltyText,
      reminderTastingTemplate: formValues.formData.reminderTastingTemplate,
      cancelationLoyaltyFreeText: formValues.formData.cancelationLoyaltyFreeText
    };
    console.log('obj:', obj);
    const url = `/${this.baseURL}/offer/${id}/prm-notification`;
    return this.http.put(url, obj, { responseType: 'text' });
  }

  public getOfferChargeCodes(offerId: number): Observable<any> {
    const url = `/${this.baseURL}/offer/${offerId}/charge-codes`;
    return this.http.get<any>(url);
  }

  private buildChargeCodeForEdit(landlineService, obj, formValues, eligibilityUserPlans) {

    if(landlineService == true){
      obj.chargeCodes = this.buildLandlineChargeCodes(formValues.formData, 'chargeCodes');
      obj.discountChargeCodes = this.buildLandlineChargeCodes(formValues.formData, 'discountChargeCodes');
      obj.penaltyChargeCodes = this.buildLandlineChargeCodes(formValues.formData, 'penaltyChargeCodes');
    }else{
      obj.chargeCodes = this.buildNonLandlineChargeCodes(formValues.formData, 'chargeCodes');
      obj.discountChargeCodes = this.buildNonLandlineChargeCodes(formValues.formData, 'discountChargeCodes');
      obj.penaltyChargeCodes = this.buildNonLandlineChargeCodes(formValues.formData, 'penaltyChargeCodes');
    }

    return obj;
  }

  private buildLandlineChargeCodes(formData, fieldName) {
    const fieldPrefix = fieldName + '-';

    return Object.keys(formData)
      .filter(key => key.indexOf(fieldPrefix) === 0 && formData[key])
      .map(key => ({
        userPlan: key.substring(fieldPrefix.length),
        chargingCode: formData[key]
      }));
  }

  private buildNonLandlineChargeCodes(formData, fieldName) {
    const chargeCodes = [];
    const anyChargeCode = formData[fieldName + '-ANY'] ?? formData[fieldName + '-'];
    const instantPaymentChargeCode = formData[fieldName + '-INSTANT_PAYMENT'];

    if(anyChargeCode){
      chargeCodes.push({
        userPlan: 'ANY',
        chargingCode: anyChargeCode
      });
    }
    if(instantPaymentChargeCode){
      chargeCodes.push({
        userPlan: 'INSTANT_PAYMENT',
        chargingCode: instantPaymentChargeCode
      });
    }

    return chargeCodes.length ? chargeCodes : null;
  }

  public updateOfferChargeCodes(id, formValues, eligibilityUserPlans, landlineService): any {
    console.log('formValues:', formValues);
    let obj = {
      chargeCodes: [],
      discountChargeCodes: [],
      penaltyChargeCodes: []
    }
    obj = this.buildChargeCodeForEdit(landlineService, obj, formValues, eligibilityUserPlans);
    console.log('obj:', obj);
    const url = `/${this.baseURL}/offer/${id}/charge-codes`;

    const payload: any = { chargeCodes: obj.chargeCodes };
    if (obj.discountChargeCodes?.length) {
      payload.discountChargeCodes = obj.discountChargeCodes;
    }
    if (obj.penaltyChargeCodes?.length) {
      payload.penaltyChargeCodes = obj.penaltyChargeCodes;
    }

    return this.http.put(url, payload, { responseType: 'text' });
  }

  public getOfferTributes(offerId: number): Observable<OfferTributes> {
    const url = `/${this.baseURL}/offer/${offerId}/tributes`;
    return this.http.get<OfferTributes>(url);
  }

  public getNumberOffers = (productId: number, globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/offer/count?productId=${productId}&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getOffersByProductId = (
    productId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Offer[]> => {
    const url =
      `/${this.baseURL
      }/offer?productId=${productId}&page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Offer[]>(url);
  }

  public getOffersNotActivesByProductId(id: number): Observable<Offer> {
    const url = `/${this.baseURL}/product/${id}/offer/notActive`;
    return this.http.get<any[]>(url).pipe(pluck('responseData'));
  }

  public getProductById(productId: number): Observable<Product> {
    const url = `/${this.baseURL}/product/${productId}`;
    return this.http.get<Product>(url);
  }

  public getNumberProductByPartnerId = (
    globalFilter?: any,
    myFilters?: any
  ): Observable<number> => {

    console.log(globalFilter, myFilters);
    const url =
      `/${this.baseURL}/product/count?` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getProductByPartnerId = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any> => {
    console.log(globalFilter, myFilters);
    const url =
      `/${this.baseURL}/product?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public getProductDependenciesByOfferId(offerId: number): Observable<ProductDependency[]> {
    const url = `/${this.baseURL}/offer/${offerId}/dependencies`;
    return this.http.get<ProductDependency[]>(url).pipe(pluck('responseData'));
  }

  public getProductDependenciesByProductId(productId: number): Observable<ProductDependency[]> {
    const url = `/${this.baseURL}/product/${productId}/dependencies`;
    return this.http.get<ProductDependency[]>(url).pipe(pluck('responseData'));
  }

  public getNumberProducts = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/product/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getProducts = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any> => {
    const url =
      `/${this.baseURL}/product?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public getProductsByPartnerId(partnerId: number, size: number = 10): Observable<Product[]> {
    let url = `/${this.baseURL}/product?partnerId=${partnerId}&ascending=true&sort=name`;
    size ? url = url + "&size=" + size : null;
    //return this.http.get<Product[]>(url).pipe(pluck('responseData'));
    return this.http.get<Product[]>(url);
  }

  public getOfferByProductId(productId: number, size: number = 10): Observable<Product[]> {
    let url = `/${this.baseURL}/offer?productId=${productId}&ascending=true&sort=name`;
    size ? url = url + "&size=" + size : null;
    //return this.http.get<Product[]>(url).pipe(pluck('responseData'));
    return this.http.get<Product[]>(url);
  }

  public getOfferDetail(offerId: number): Observable<Offer[]> {
    let url = `/${this.baseURL}/offer/${offerId}`;
    return this.http.get<Offer[]>(url);
  }

  public getProductsNotActivesOffers(
    offset: number = null,
    pageIncrement: number = null
  ): Observable<{ responseData: Product[]; totalResultSize: number }> {
    const url = `/${this.baseURL}/notActives`;
    const queryParameters = this.helperService.setHttpQueryParameters([
      { name: 'page', value: offset === 0 ? 1 : offset },
      { name: 'size', value: pageIncrement },
    ]);
    return this.http.get<{ responseData: Product[]; totalResultSize: number }>(url, { params: queryParameters });
  }

  public getOfferNotifsById(offerId: number): any {
    const url = `/${this.baseURL}/offer/${offerId}/notification`;
    return this.http.get(url);
  }

  public getOfferMtsById(offerId: number): any {
    const url = `/${this.baseURL}/offer/${offerId}/communication/mts`;
    return this.http.get(url);
  }

  public getOfferChannelsById(offerId: number): any {
    const url = `/${this.baseURL}/offer/${offerId}/communication/channel`;
    return this.http.get(url);
  }

  public getOfferCampaignByIdAll(offerId, limit='') {
    const url =`/${this.baseURL}/campaign?offerId=${offerId}&size=${limit}&ascending=false`;
    return this.http.get(url);
  }

  public getOfferCampaignById = (
    offerId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ) => {
    const url =
      `/${this.baseURL
      }/campaign?offerId=${offerId}&page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public tableSortOrderLogic(sortOrder) {
    return sortOrder === 1 ? (sortOrder = true) : (sortOrder = false);
  }

  public tableSortLogic(sort) {
    return (sort = sort ? '&sort=' + sort : '');
  }

  public tableGlobalFilterLogic(globalFilter) {
    return (globalFilter = globalFilter ? '&globalFilter=' + globalFilter : '');
  }

  public tableFilterLogic(myFilters) {
    if (myFilters) {
      let filters = '';
      let filterFields = Object.keys(myFilters);
      filterFields.map((filterField, i) => {
        const filterValue = myFilters[filterField]?.value
          ? myFilters[filterField].value
          : typeof myFilters[filterField] == 'string'
            ? myFilters[filterField]
            : '';

        if (filterField != 'global' && filterValue) {
          if (i == 0) {
            filters = '&' + filters + filterField + '=' + filterValue;
          } else {
            filters = filters + '&' + filterField + '=' + filterValue;
          }
        }
      });
      return (myFilters = filters);
    } else {
      return (myFilters = '');
    }
  }

  public getOfferCampaignCount = (offerId: number, globalFilter?: any, myFilters?: any) => {
    const url =
      `/${this.baseURL}/campaign/count?offerId=${offerId}` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public getOfferCampaignDetailsById(campaignId: number): any {
    const url = `/${this.baseURL}/campaign/${campaignId}`;
    return this.http.get(url);
  }

  public newCreateProductOneShot(formValues) {
    const url = `/${this.baseURL}/product/create/oneshot`;
    formValues.realmId = "426";
    formValues.xConn = 55000805;
    formValues.channels = [1];
    formValues.chargeDirection = formValues.chargeDirection.id;
    formValues.productStatus = formValues.productStatus.id;
    formValues.partnerId = formValues.partnerData.id;
    formValues.partnerServiceId = formValues.partnerData.partnerServiceId;
    delete formValues.partnerData;
    return this.http.post(url, formValues, { responseType: 'text' });
  }

  public additionalChargeInfoISSTaxIncluded(value1, value2, value3, value4) {

    if(value1 === false && value2 === false && value3 === false && value4 === false){
      return {text:'', code: '0000'};
    }
    else if(value1 === true && value2 === true && value3 === true && value4 === true){
      return {text:'', code: '1111'};
    }
    else if(value1 === true && value2 === false && value3 === false && value4 === false){
      return {text:'', code: '1000'};
    }
    else if(value1 === false && value2 === true && value3 === false && value4 === false){
      return {text:'', code: '0100'};
    }
    else if(value1 === true && value2 === true && value3 === false && value4 === false){
      return {text:'', code: '1100'};
    }
    else if(value1 === false && value2 === true && value3 === true && value4 === false){
      return {text:'', code: '0110'};
    }
    else if(value1 === false && value2 === false && value3 === true && value4 === false){
      return {text:'', code: '0010'};
    }
    else if(value1 === true && value2 === false && value3 === true && value4 === false){
      return {text:'', code: '1010'};
    }
    else if(value1 === true && value2 === true && value3 === false && value4 === false){
      return {text:'', code: '1110'};
    }
    else if(value1 === false && value2 === false && value3 === false && value4 === true){
      return {text:'', code: '0001'};
    }
    else if(value1 === true && value2 === false && value3 === false && value4 === true){
      return {text:'', code: '1001'};
    }
    else if(value1 === false && value2 === true && value3 === false && value4 === true){
      return {text:'', code: '0101'};
    }
    else if(value1 === false && value2 === true && value3 === true && value4 === true){
      return {text:'', code: '0111'};
    }
    else {
      return {
        text:'Com cobrança do valor de impostos para o cliente (recebimento do valor líquido), sem avanço de crédito sem cobrança de conteúdos em fatura a isento de repasse.',
        code: '0000'
      };
    }
  }

  public buildArrayChannels(channels: { code: string, name: string }[], submitType='') {
    let channelsData:any = [];
    if (channels) {
      if(submitType == 'create'){
        channels.forEach(channel => {
          channelsData.push(channel.name)
        })
      } else {
        channels.forEach(channel => {
          channelsData.push({ id: null, entryChannelKey: channel.name })
        })
      }
    }
    return channelsData
  }

  public buildStepDownSteps(array, period) {
    let resultArray = [];
    array.forEach((element, index) => {
      resultArray.push({
        index: index,
        period: period,
        periodValue: element.applyStepDownValue,
        amount: element.applyStepDownPrice
      });
    });
    return resultArray;
  }

  private checkChargingTypes(offertype, chargeType) {
    if(offertype === 'subscricao') {
      return 'DOB';
    } else {
      return chargeType;
    }
  }

  public buildArrayElegibility(formValues): any[] {
    let eligibility: any[] = []
    if(formValues.length > 0){
      formValues.forEach((element, index) => {
        eligibility.push({
          eligibilityId: index + 1,
          eligibilityName: element.name,
          paymentTypeIds: [1, 2]
        })
      });
    }
    return eligibility;
  }

  private prepareDataEligibility(arr: any = [], edit=false) {

    if(arr){
      let chargingCodes = [];

      chargingCodes = arr.map(data => {
        return {
          eligibilityName: edit ? data.split("|")[0] : data.id.split("|")[0], 
          paymentTypeIds: edit ? data.split("|")[1] : data.id.split("|")[1], 
        }
      });

      chargingCodes = this.groupByEligibility(chargingCodes);

      console.log("DEBUG (saveElegibility):", arr, chargingCodes);

      return chargingCodes;
    }
    return arr;
  }

  private groupByEligibility(arr) {
    return Object.values(
      arr.reduce((acc, { eligibilityName, paymentTypeIds }) => {
        if (!acc[eligibilityName]) {
          acc[eligibilityName] = { 
            eligibilityName, 
            paymentTypeIds: [] 
          };
        }
        acc[eligibilityName].paymentTypeIds.push(paymentTypeIds);
        return acc;
      }, {})
    );
  }

  public createProductNavigation(formValues): any {
    console.log('createProductNavigation:');
    const url = `/${this.baseURL}/product/navigation`;
    const realmId = '426';

    console.log('formValues:', formValues);
    let product: any = {}
    product.partnerId = formValues.partnerId?.id
    ;
    product.realmId = realmId;
    product.shortCode = formValues.shortCode;
    product.alphaTag = formValues.alphaTag;
    product.productName = formValues.productName ;
    product.productDescription = formValues.productDescription ;
    product.getUserBasicProfile = formValues.getUserBasicProfile?.id  ;
    product.createGenericKeyWord = formValues.offerChannelGenericKeywords;
    console.log('url:', url);
    console.log('product:', product);

    return this.http.post(url, product, { responseType: 'text' });

  }

  public createProductSubscription(formValues, submitType=''): any {

    console.log('formValues:', formValues);

    const url = `/${this.baseURL}/product/create/subscription`;

    const realmId = '426';

    let product: any = {}

    let offers: any = {}

    offers = Object.assign(offers, formValues.formDataOffer);
    if(!formValues.formDataOffer.needSubscribe){
      offers = Object.assign(offers, formValues.formDataOfferCommunication);
    }
    offers = Object.assign(offers, formValues.formDataOfferPriceModel);
    product = Object.assign(product, formValues.formData);
    product = Object.assign(product, formValues.formDataNotificationPartner);

    this.removeFieldsForSubscriptionProduct(product, 'product')
    this.removeFieldsForSubscriptionProduct(offers, 'offer')
    // product
    product.partnerId = formValues.formData?.partnerId?.id;
    product.productDescription = formValues.formData.productDescription;
    product.productName = formValues.formData.productName;
    product.realmId = Number(realmId);
    product.shortCode = formValues.formData.shortCode;
    product.alphaTag = formValues.formData.alphaTag;
    product.datasyncUrl = formValues.formData.datasyncUrl;
    product.vivoProductId = '';
    product.vivoServiceId = '';
    product.notification = {
      productDefOp : 0,
      realmId : Number(realmId),
      subsNotifyBss : formValues.formDataNotificationPartner.subsNotifyBSS,
      bssNotificationCodigoFuncionalidades : formValues.formDataNotificationPartner.bssNotificationCodigoFuncionalidades,
      bssNotificationNomeServico : formValues.formDataNotificationPartner.bssNotificationNomeServico,
      bssNotificationSigaFluxo : formValues.formDataNotificationPartner.bssNotificationSigaFluxo,
      bssNotificationCdProduto : formValues.formDataNotificationPartner.cdProduto,
      failReasonToPartner : formValues.formDataNotificationPartner.failReasonToPartner,
      extensionNotify : formValues.formDataNotificationPartner.extensionNotify.id?.toString(),
      getUserBasicProfile : formValues.formDataNotificationPartner.getUserBasicProfile.id,
      subscriptionUrl: formValues.formDataNotificationPartner.datasyncUrl,
      changeMsisdnUrl : formValues.formDataNotificationPartner.changeMsisdnUrl,
      ussdUrl : formValues.formDataNotificationPartner.ussdUrl,
      moUrl : formValues.formDataNotificationPartner.moUrl,
      isGenerateCDR : formValues.formDataNotificationPartner.isGenerateCDR,
      byPassSubValidationUserBasicProfile : formValues.formDataNotificationPartner.byPassSubValidationUserBasicProfile
    };
    product.communicationKeyword = {
      keywordCancel: formValues.formData.kwCancel ? formValues.formData.kwCancel : [],
      keywordsBlock: formValues.formData.kwBlock ? formValues.formData.kwBlock : [],
      keywordsUnblock: formValues.formData.kwUnblock ? formValues.formData.kwUnblock : [],
      keywordsHelp: formValues.formData.kwHelp ? formValues.formData.kwHelp : [],
      keywordsDoubleOptinConfirmation: formValues.formData.keywordsDoubleOptinConfirmation ? formValues.formData.keywordsDoubleOptinConfirmation : [],
      keywordsDoubleOptinNegation: formValues.formData.keywordsDoubleOptinNegation ? formValues.formData.keywordsDoubleOptinNegation : []
    };
    product.createProductNavegation = formValues.formDataOffer.createProductNavegation;
    product.typeService = formValues.formDataOffer.offerType.id === 'subscricao' ? 1 : 3;
    product.isInternalManagedProduct = formValues.formData.isInternalManagedProduct;
    // offer
    offers.additionalChargeInfoISSTaxIncluded = this.additionalChargeInfoISSTaxIncluded(
      formValues.formDataOffer.TaxIncluded,
      formValues.formDataOffer.creditLoan,
      formValues.formDataOffer.CTRaccount.id,
      formValues.formDataOffer.ISSTaxIncluded
    ).code;
    let usedElegibility;
    if(formValues.formDataOffer.isFixedLine?.id === 'yes'){
      usedElegibility = formValues.formDataOffer.eligibilityLandline;
    }else{
      if(formValues.formDataOffer.isBundlePreDiario){
        usedElegibility = formValues.formDataOffer.eligibilityPreBundle;
      }else{
        usedElegibility = formValues.formDataOffer.eligibility;
      }
    }
    //const usedElegibility = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.eligibilityLandline : formValues.formDataOffer.eligibility;
    offers.eligibility = this.prepareDataEligibility(usedElegibility);
    offers.freePeriod = formValues.formDataOfferPriceModel.isTryAndBuy.id;
    offers.isAutomaticRenew = formValues.formDataOffer.isAutomaticRenew;
    offers.isLinhafixa = formValues.formDataOffer.isFixedLine?.id === 'yes' ? true : false;
    offers.controlMode = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.controlMode.id.toUpperCase() : '';
    //offers.controlMode = formValues.formDataOffer.controlMode.id.toUpperCase();
    offers.colabChargingFree = formValues.formDataOfferPriceModel.colabChargingFree;
    offers.hasGvp = formValues.formDataOffer.hasGvp;
    offers.gvpCode = formValues.formDataOffer.gvpCode;
    offers.hasUrn = formValues.formDataOffer.hasUrn;
    offers.urnCode = formValues.formDataOffer.urnCode;

    /* this code is comment because the BE ready comment this too and I we need confirm
    if(formValues.formDataOffer.eligibilityLandline){
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibilityLandline.map(data => {
          return {userPlan: data.id, chargingCode: formValues.formDataOffer[data.id]}
        })
      };
    }
    else if(formValues.formDataOffer.chargingCode){
      offers.chargingCodes = {
        chargeCodes: [{chargingCode: formValues.formDataOffer.chargingCode}]
      };
    }*/
    
    if(formValues.formDataOffer.isFixedLine?.id === 'yes'){
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibilityLandline.map(data => {
          return {
            userPlan: data.id.split("|")[0], 
            chargingCode: formValues.formDataOffer[data.id]
          }
        })
      };
    } else {
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibility.map(data => {
          return {
            userPlan: data.id.split("|")[0], 
            chargingCode: formValues.formDataOffer.chargingCode
          }
        })
      };
    }

    if(formValues.formDataOffer.offerType.id != "avulso" || formValues.formDataOffer.needSubscribe){
      product.messages = this.getMtsList('product', formValues.formDataOfferCommunication);
      offers.trustedVendors = formValues.formDataOfferCommunication.trustedVendors;
      offers.authcodeChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptinViaPinCode, submitType);
      offers.doubleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptin, submitType);
      offers.singleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithoutDoubleOptin, submitType);
      offers.subscriptionUrl = formValues.formDataOfferCommunication.datasync;
      offers.sendClientIdentifier = formValues.formDataOfferCommunication.sendClientIdentifier;
      //emails PRM communication
      offers.prmCommunication = {
        subscriptionText: formValues.formDataOfferCommunication.subscriptionText,
        discountText: formValues.formDataOfferCommunication.discountText,
        loyaltyText: formValues.formDataOfferCommunication.loyaltyText,
        cancelationText: formValues.formDataOfferCommunication.cancelationText,
        preCancelationText: formValues.formDataOfferCommunication.preCancelationText,
        voucherText: formValues.formDataOfferCommunication.voucherText,
        svaLinkApp: formValues.formDataOfferCommunication.svaLinkApp,
        svaFreeLinkApp: formValues.formDataOfferCommunication.svaFreeLinkApp,
        doubleOptinLinkApp: formValues.formDataOfferCommunication.doubleOptinLinkApp,
        emailFixaFree: formValues.formDataOfferCommunication.emailFixaFree,
        cancelationWithPenaltyText: formValues.formDataOfferCommunication.cancelationWithPenaltyText,
        cancelationWithoutPenaltyText: formValues.formDataOfferCommunication.cancelationWithoutPenaltyText,
        reminderTastingTemplate: formValues.formDataOfferCommunication.reminderTastingTemplate,
        cancelationLoyaltyFreeText: formValues.formDataOfferCommunication.cancelationLoyaltyFreeText,
      }
      offers.messages = this.getMtsList('offer', formValues.formDataOfferCommunication)
      offers.kwActivateWithoutDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithoutSingleOptin;
      offers.kwActivateWithDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithSingleOptin;
      offers.protocolSentByPRM = formValues.formDataOfferCommunication.protocolo;
    }

    //emails PRM communication
    offers.isPreCancel = formValues.formDataOfferPriceModel.isPreCancel.id;
    offers.profileQuery = formValues.formDataOffer.profileQuery;
    offers.isSchedulingRate = formValues.formDataOfferPriceModel.isSchedulingRate;
    offers.isSendChargeFee = formValues.formDataOffer.sendChargeFee;
    offers.isNotifySPFailProcess = formValues.formDataOffer.notifySPFailProcess;
    offers.chargeDescription = formValues.formDataOffer.offerType.id === 'subscricao' ? formValues.formDataOffer.chargeDescription : formValues.formDataOffer.chargeDescriptionOneShot;
    offers.isSuspended = formValues.formDataOfferPriceModel.isSuspended;
    offers.moUrl = formValues.formDataOffer.moUrl;
    offers.msgDTOList = formValues.formDataOffer.msgDTOList;
    offers.offerName = formValues.formDataOffer.offerName;
    offers.onTopOf = formValues.formDataOffer.onTopOf;
    offers.replaceOffer = formValues.formDataOffer.replaceOffer;
    offers.notifyReplaceSubTempState = formValues.formDataOffer.notifyReplaceSubTempState;
    offers.partnerId = formValues?.formData?.partnerId?.id;
    offers.period = formValues.formDataOffer.period.id;
    offers.periodValue = formValues.formDataOffer.periodValue;
    offers.productDescription = formValues.formData.productDescription;
    offers.productName = formValues.formData.productName;
    offers.realmId = Number(realmId);
    offers.taxValue = this.additionalChargeInfoISSTaxIncluded(false, false, false, false).code;
    offers.retry = [
      {
        retries: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryTimes,
        interval: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryInterval,
        msgDefKey: "ACTIVATE_BSS_PROVISIONING_MESSAGE"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryInterval,
        msgDefKey: "CHARGE_DOB_NOTIF"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyVendorRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyVendorRetryInterval,
        msgDefKey: "VENDOR_CHARGE_DOB_NOTIF"
      }
    ],
    offers.schedulingRates = formValues.formDataOfferPriceModel.schedulingRates.map((data, index) => {
      data.priority = index + 1;
      return data;
    });

    offers.stepDown = {
      type: formValues.formDataOfferPriceModel.stepDownOption.id,
      application: formValues.formDataOfferPriceModel.applyStepDown.id,
      automatic: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            minAmount: 1,
            entity: ""
        }
      ],
      configured: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
        }
      ],
      steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
    };
    offers.subPrice = Number(formValues.formDataOfferPriceModel.subPrice);
    offers.renewPrice = Number(formValues.formDataOfferPriceModel.renewPrice);
    offers.ussdNotificationUrl = formValues.formDataOffer.ussdNotificationUrl;
    offers.vivoProductId = '';
    offers.vivoServiceId = '';
    offers.keywordsDoubleOptinConfirmation = [];
    offers.keywordsDoubleOptinNegation = [];
    offers.companyOwner = formValues.formDataOfferPriceModel.companyOwner.id,
    offers.priorityRenovationTopUp = formValues.formDataOffer.renewPriority.id;
    offers.multipleLicense = formValues.formDataOffer.multipleLicense;
    offers.campaignPeriodValue = formValues.formDataOfferPriceModel.TryAndBuyPeriodValue;
    offers.chargeDirection = this.checkChargingTypes(formValues.formDataOffer.offerType.id, formValues.formDataOffer.chargingType.id);
    offers.maxPrice = formValues.formDataOffer.maxPrice;
    offers.tasting = formValues.formDataOffer.tasting;
    offers.howToUse = formValues.formDataOffer.howToUseStep.map(data => data.howToUseStepItem);
    offers.tributes = {
      cClassCode: formValues.formDataOffer.cClassCode
    };
    offers.bannerUrl = formValues.formDataOffer.bannerUrl;
    offers.commercialDescription = formValues.formDataOffer.commercialDescription;
    offers.resumedDescription = formValues.formDataOffer.resumedDescription;
    offers.benefits = formValues.formDataOffer.benefits;

    offers.cclasTrib = formValues.formDataOffer.cclasTrib;
    offers.cstPisCofins = formValues.formDataOffer.cstPisCofins;
    offers.cstIbsCbs = formValues.formDataOffer.cstIbsCbs;
    offers.clndop = formValues.formDataOffer.clndop;
    offers.nbs = formValues.formDataOffer.nbs;
    if(formValues.formDataOffer.issqn){
      offers.issqn = formValues.formDataOffer.issqn.split("-")[0];
    }
    offers.nationalTaxCode = formValues.formDataOffer.nationalTaxCode;
    offers.codeService = formValues.formDataOffer.codeService;
    offers.allowShowOfferCatalogNoClient = formValues.formDataOffer.allowShowOfferCatalogNoClient;
    offers.allowShowOfferCatalogSvaOnly = formValues.formDataOffer.allowShowOfferCatalogSvaOnly;

    if(formValues.formDataOffer.preReservation){
      offers.preReservation = formValues.formDataOffer.preReservation.id;
    }

    product.offer = offers;

    console.log('finalObj:', product);

    return this.http.post(url, product, { responseType: 'text' });

  }

  public createOffer(formValues, submitType='', productId): any {

    console.log('formValues:', formValues, submitType, productId);

    const url = `/${this.baseURL}/offer/create`;

    const realmId = '426';

    let offers: any = {}

    offers = Object.assign(offers, formValues.formDataOffer);
    if(!formValues.formDataOffer.needSubscribe){
      offers = Object.assign(offers, formValues.formDataOfferCommunication);
    }
    offers = Object.assign(offers, formValues.formDataOfferPriceModel);

    this.removeFieldsForSubscriptionProduct(offers, 'offer')

    // offer
    offers.additionalChargeInfoISSTaxIncluded = this.additionalChargeInfoISSTaxIncluded(
      formValues.formDataOffer.TaxIncluded,
      formValues.formDataOffer.creditLoan,
      formValues.formDataOffer.CTRaccount.id,
      formValues.formDataOffer.ISSTaxIncluded
    ).code;

    offers.productType = formValues.formDataOffer.offerType.id == "subscricao" ? "SUBSCRIPTION" : "ONE_SHOT"
    const usedElegibility = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.eligibilityLandline : formValues.formDataOffer.eligibility;
    //offers.eligibility = this.buildArrayElegibility(usedElegibility);
    offers.eligibility = this.prepareDataEligibility(usedElegibility);
    offers.isAutomaticRenew = formValues.formDataOffer.isAutomaticRenew;
    offers.isLinhafixa = formValues.formDataOffer.isFixedLine?.id === 'yes' ? true : false;
    offers.controlMode = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.controlMode.id.toUpperCase() : '';
    //offers.controlMode = formValues.formDataOffer.controlMode.id.toUpperCase();
    offers.colabChargingFree = formValues.formDataOfferPriceModel.colabChargingFree;
    offers.hasGvp = formValues.formDataOffer.hasGvp;
    offers.gvpCode = formValues.formDataOffer.gvpCode;
    offers.hasUrn = formValues.formDataOffer.hasUrn;
    offers.urnCode = formValues.formDataOffer.urnCode;
    offers.regretPeriod = formValues.formDataOffer.regretPeriod;
    if(formValues.formDataOffer.eligibilityLandline){
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibilityLandline.map(data => {
          return {userPlan: data.id, chargingCode: formValues.formDataOffer[data.id]}
        })
      };
    }
    else if(formValues.formDataOffer.chargingCode){
      offers.chargingCodes = {
        chargeCodes: [
          {
            chargingCode: formValues.formDataOffer.chargingCode
          }
        ]
      };
    }

    if(formValues.formDataOffer.isFixedLine?.id === 'yes'){
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibilityLandline?.map(data => {
          return {
            userPlan: data.id.split("|")[0], 
            chargingCode: formValues.formDataOffer[data.id]
          }
        }) || []
      };
    } else if(formValues.formDataOffer.eligibility?.length > 0){
      let chargeCodes = [];
      const creditCardPaymentTypeId = formValues.creditCardPaymentTypeId;
      
      offers.chargingCodes = {
        chargeCodes: formValues.formDataOffer.eligibility.map(data => {
          const eligibilityName = data.id.split("|")[0];
          const paymentTypeId = data.id.split("|")[1];
          const isCreditCard = creditCardPaymentTypeId && paymentTypeId === creditCardPaymentTypeId;
          
          return {
            userPlan: eligibilityName,
            chargingCode: isCreditCard
              ? formValues.formDataOffer.chargingCodeCreditCard
              : formValues.formDataOffer.chargingCode
          }
        }) || []
      };
    } else if(formValues.formDataOffer.chargingCode){
      offers.chargingCodes={
        chargeCodes: [
        {
          userPlan: "ANY",  
          chargingCode: formValues.formDataOffer.chargingCode
        }
      ]};
    }

    //emails PRM communication
    offers.isPreCancel = formValues.formDataOfferPriceModel.isPreCancel.id;
    offers.profileQuery = formValues.formDataOffer.profileQuery;
    offers.isSendChargeFee = formValues.formDataOffer.sendChargeFee;
    offers.isNotifySPFailProcess = formValues.formDataOffer.notifySPFailProcess;
    offers.chargeDescription = formValues.formDataOffer.offerType.id === 'subscricao' ? formValues.formDataOffer.chargeDescription : formValues.formDataOffer.chargeDescriptionOneShot;
    offers.isSuspended = formValues.formDataOfferPriceModel.isSuspended;
    offers.moUrl = formValues.formDataOffer.moUrl;
    offers.msgDTOList = formValues.formDataOffer.msgDTOList;
    offers.offerName = formValues.formDataOffer.offerName;
    offers.onTopOf = formValues.formDataOffer.onTopOf;
    offers.replaceOffer = formValues.formDataOffer.replaceOffer;
    offers.notifyReplaceSubTempState = formValues.formDataOffer.notifyReplaceSubTempState;
    offers.period = formValues.formDataOffer.period.id;
    offers.periodValue = formValues.formDataOffer.periodValue;
    offers.productDescription = formValues.formDataOffer.description;
    offers.realmId = Number(realmId);
    offers.taxValue = this.additionalChargeInfoISSTaxIncluded(false, false, false, false).code;
    offers.retry = [
      {
        retries: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryTimes,
        interval: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryInterval,
        msgDefKey: "ACTIVATE_BSS_PROVISIONING_MESSAGE"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryInterval,
        msgDefKey: "CHARGE_DOB_NOTIF"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyVendorRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyVendorRetryInterval,
        msgDefKey: "VENDOR_CHARGE_DOB_NOTIF"
      }
    ]

    offers.stepDown = {
      type: formValues.formDataOfferPriceModel.stepDownOption.id,
      application: formValues.formDataOfferPriceModel.applyStepDown.id,
      automatic: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            minAmount: 1,
            entity: ""
        }
      ],
      configured: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
        }
      ],
      steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
    };
    offers.subPrice = Number(formValues.formDataOfferPriceModel.subPrice);
    offers.renewPrice = Number(formValues.formDataOfferPriceModel.renewPrice);
    offers.ussdNotificationUrl = formValues.formDataOffer.ussdNotificationUrl;
    offers.vivoProductId = '';
    offers.vivoServiceId = '';
    offers.keywordsDoubleOptinConfirmation = [];
    offers.keywordsDoubleOptinNegation = [];
    offers.companyOwner = formValues.formDataOfferPriceModel.companyOwner.id,
    offers.priorityRenovationTopUp = formValues.formDataOffer.renewPriority.id;
    offers.multipleLicense = formValues.formDataOffer.multipleLicense;
    offers.chargeDirection = this.checkChargingTypes(formValues.formDataOffer.offerType.id, formValues.formDataOffer.chargingType.id);
    offers.maxPrice = formValues.formDataOffer.maxPrice;
    offers.tasting = formValues.formDataOffer.tasting;
    offers.ruleForPreRegisterActiveOfferId = offers.tasting ? formValues.formDataOffer.preRegisterActiveOfferId : null;
    offers.preRegisterActiveOfferId = offers.ruleForPreRegisterActiveOfferId;
    offers.howToUse = formValues.formDataOffer.howToUseStep.map(data => data.howToUseStepItem);
    offers.bannerUrl = formValues.formDataOffer.bannerUrl;
    offers.commercialDescription = formValues.formDataOffer.commercialDescription;
    offers.resumedDescription = formValues.formDataOffer.resumedDescription;
    offers.benefits = formValues.formDataOffer.benefits;
    offers.planChangeOfferId = formValues.formDataOffer.planChangeOfferId;
    offers.allowShowOfferCatalogNoClient = formValues.formDataOffer.allowShowOfferCatalogNoClient;
    offers.allowShowOfferCatalogSvaOnly = formValues.formDataOffer.allowShowOfferCatalogSvaOnly;
    offers.shouldNotifyPreCancel = formValues.formDataOffer.shouldNotifyPreCancel;

    offers.cclasTrib = formValues.formDataOffer.cclasTrib;
    offers.cstPisCofins = formValues.formDataOffer.cstPisCofins;
    offers.cstIbsCbs = formValues.formDataOffer.cstIbsCbs;
    offers.clndop = formValues.formDataOffer.clndop;
    offers.nbs = formValues.formDataOffer.nbs;
    if(formValues.formDataOffer.issqn){
      offers.issqn = formValues.formDataOffer.issqn.split("-")[0];
    }
    offers.nationalTaxCode = formValues.formDataOffer.nationalTaxCode;
    offers.codeService = formValues.formDataOffer.codeService;

    if(formValues.formDataOffer.preReservation){
      offers.preReservation = formValues.formDataOffer.preReservation.id;
    }

    offers.productId = productId;

    offers.tributes = {
      cClassCode: formValues.formDataOffer.cClassCode
    };
    
    offers.tastingOffer = {
        tastingOfferId: null,
        tastingProductDefOpId: productId,
        isTastingPrimary: formValues.tastingOffer.length == 0 ? true : false,
        linkedOfferId: offers.preRegisterActiveOfferId,
        linkedTastingOfferId: formValues.tastingOffer.length == 0 ? null : formValues.tastingOffer[0]?.id,
        skipTastingOnActivated: formValues.formDataOffer.skipTastingOnActivated
    };

    if(formValues.formDataOffer.offerType.id != "avulso" || formValues.formDataOffer.needSubscribe){
      offers.trustedVendors = formValues.formDataOfferCommunication.trustedVendors
      offers.authcodeChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptinViaPinCode, submitType)
      offers.doubleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptin, submitType)
      offers.singleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithoutDoubleOptin, submitType)
      offers.subscriptionUrl = formValues.formDataOfferCommunication.datasync;
      offers.sendClientIdentifier = formValues.formDataOfferCommunication.sendClientIdentifier;

      offers.prmCommunication = {
        subscriptionText: formValues.formDataOfferCommunication.subscriptionText,
        discountText: formValues.formDataOfferCommunication.discountText,
        loyaltyText: formValues.formDataOfferCommunication.loyaltyText,
        cancelationText: formValues.formDataOfferCommunication.cancelationText,
        preCancelationText: formValues.formDataOfferCommunication.preCancelationText,
        voucherText: formValues.formDataOfferCommunication.voucherText,
        svaLinkApp: formValues.formDataOfferCommunication.svaLinkApp,
        svaFreeLinkApp: formValues.formDataOfferCommunication.svaFreeLinkApp,
        doubleOptinLinkApp: formValues.formDataOfferCommunication.doubleOptinLinkApp,
        emailFixaFree: formValues.formDataOfferCommunication.emailFixaFree,
        cancelationWithPenaltyText: formValues.formDataOfferCommunication.cancelationWithPenaltyText,
        cancelationWithoutPenaltyText: formValues.formDataOfferCommunication.cancelationWithoutPenaltyText,
        reminderTastingTemplate: formValues.formDataOfferCommunication.reminderTastingTemplate,
        cancelationLoyaltyFreeText: formValues.formDataOfferCommunication.cancelationLoyaltyFreeText,
      }

      offers.messages = this.getMtsList('offer', formValues.formDataOfferCommunication)
      offers.kwActivateWithoutDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithoutSingleOptin;
      offers.kwActivateWithDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithSingleOptin;
      offers.protocolSentByPRM = formValues.formDataOfferCommunication.protocolo;
    }

    return this.http.post(url, offers, { responseType: 'text' });

  }

  public createPackage(formValues, submitType=''): any {

    console.log('formValues:', formValues);

    const url = `/${this.baseURL}/package/create`;

    const realmId = '426';

    let offers: any = {}

    offers = Object.assign(offers, formValues.formDataOffer);
    offers = Object.assign(offers, formValues.formDataOfferCommunication);
    offers = Object.assign(offers, formValues.formDataOfferPriceModel);

    this.removeFieldsForSubscriptionProduct(offers, 'offer')

    // offer
    offers.additionalChargeInfoISSTaxIncluded = this.additionalChargeInfoISSTaxIncluded(
      formValues.formDataOffer.TaxIncluded,
      formValues.formDataOffer.creditLoan,
      formValues.formDataOffer.CTRaccount.id,
      formValues.formDataOffer.ISSTaxIncluded
    ).code;

    offers.trustedVendors = formValues.formDataOfferCommunication.trustedVendors
    offers.authcodeChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptinViaPinCode, submitType)
    offers.doubleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptin, submitType)
    offers.singleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithoutDoubleOptin, submitType)
    const usedElegibility = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.eligibilityLandline : formValues.formDataOffer.eligibility;
    offers.eligibility = this.buildArrayElegibility(usedElegibility);
    offers.isAutomaticRenew = formValues.formDataOffer.isAutomaticRenew;
    offers.suspensionPermition = formValues.formDataOffer.suspensionPermition;
    offers.isLinhaFixa = formValues.formDataOffer.isFixedLine?.id === 'yes' ? true : false;
    offers.controlMode = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.controlMode.id.toUpperCase() : '';
    offers.sendClientIdentifier = formValues.formDataOfferCommunication.sendClientIdentifier;
    offers.cancelBypass = formValues.formDataNotificationPackage.cancelBypass;
    offers.blacklistBypass = formValues.formDataNotificationPackage.blacklistBypass;
    offers.chargingCodes = {
      chargeCodes: formValues.formDataOffer.eligibilityLandline ? formValues.formDataOffer.eligibilityLandline.map(data =>{
        return { userPlan: data.id.split("|")[0], chargingCode: formValues.formDataOffer[data.id] };
      }) : [
        {chargingCode: formValues.formDataOffer.chargingCode}
      ]
    }
    /*offers.chargingCodes = {
      chargeCodes: formValues.formDataOffer.eligibilityLandline ? formValues.formDataOffer.eligibilityLandline.map(data => {
        return {userPlan: data.id, chargingCode: formValues.formDataOffer[data.id]}
      }): [
        {chargingCode: formValues.formDataOffer.chargingCode}
      ]
    };*/
    //emails PRM communication
    offers.prmCommunication = {
      subscriptionText: formValues.formDataOfferCommunication.subscriptionText,
      discountText: formValues.formDataOfferCommunication.discountText,
      loyaltyText: formValues.formDataOfferCommunication.loyaltyText,
      cancelationText: formValues.formDataOfferCommunication.cancelationText,
      preCancelationText: formValues.formDataOfferCommunication.preCancelationText,
      voucherText: formValues.formDataOfferCommunication.voucherText,
      svaLinkApp: formValues.formDataOfferCommunication.svaLinkApp,
      svaFreeLinkApp: formValues.formDataOfferCommunication.svaFreeLinkApp,
      doubleOptinLinkApp: formValues.formDataOfferCommunication.doubleOptinLinkApp,
      emailFixaFree: formValues.formDataOfferCommunication.emailFixaFree,
      cancelationWithPenaltyText: formValues.formDataOfferCommunication.cancelationWithPenaltyText,
      cancelationWithoutPenaltyText: formValues.formDataOfferCommunication.cancelationWithoutPenaltyText,
      reminderTastingTemplate: formValues.formDataOfferCommunication.reminderTastingTemplate
    }
    //emails PRM communication
    offers.isPreCancel = formValues.formDataOfferPriceModel.isPreCancel.id;
    offers.profileQuery = formValues.formDataOffer.searchProfileOnRenew;
    offers.isSendChargeFee = formValues.formDataOffer.sendChargeFee;
    offers.isNotifySPFailProcess = formValues.formDataOffer.notifySPFailProcess;
    offers.chargeDescription = formValues.formDataOffer.offerType.id === 'subscricao' ? formValues.formDataOffer.chargeDescription : formValues.formDataOffer.chargeDescriptionOneShot;
    offers.isSuspended = formValues.formDataOfferPriceModel.isSuspended;
    offers.moUrl = formValues.formDataOffer.moUrl;
    offers.msgDTOList = formValues.formDataOffer.msgDTOList;
    offers.offerName = formValues.formDataOffer.offerName;
    offers.onTopOf = formValues.formDataOffer.onTopOf;
    offers.replaceOffer = formValues.formDataOffer.replaceOffer;
    offers.notifyReplaceSubTempState = formValues.formDataOffer.notifyReplaceSubTempState;
    offers.period = formValues.formDataOffer.period.id;
    offers.periodValue = formValues.formDataOffer.periodValue;
    offers.productDescription = formValues.formDataOffer.description;
    offers.realmId = Number(realmId);
    offers.taxValue = this.additionalChargeInfoISSTaxIncluded(false, false, false, false).code;
    offers.retry = [
      {
        retries: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryTimes,
        interval: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryInterval,
        msgDefKey: "ACTIVATE_BSS_PROVISIONING_MESSAGE"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryInterval,
        msgDefKey: "CHARGE_DOB_NOTIF"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyVendorRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyVendorRetryInterval,
        msgDefKey: "VENDOR_CHARGE_DOB_NOTIF"
      }
    ]

    offers.stepDown = {
      type: formValues.formDataOfferPriceModel.stepDownOption.id,
      application: formValues.formDataOfferPriceModel.applyStepDown.id,
      automatic: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            minAmount: 1,
            entity: ""
        }
      ],
      configured: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
        }
      ],
      steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
    };
    offers.subPrice = Number(formValues.formDataOfferPriceModel.subPrice);
    offers.renewPrice = Number(formValues.formDataOfferPriceModel.renewPrice);
    offers.ussdNotificationUrl = formValues.formDataOffer.ussdNotificationUrl;
    offers.vivoProductId = '';
    offers.vivoServiceId = '';
    offers.keywordsDoubleOptinConfirmation = [];
    offers.keywordsDoubleOptinNegation = [];
    offers.billingCompany = formValues.formDataOfferPriceModel.billingCompany.id;
    offers.priorityRenovationTopUp = formValues.formDataOffer.renewPriority.id;
    offers.multipleLicense = formValues.formDataOffer.multipleLicense;
    offers.messages = this.getMtsList('offer', formValues.formDataOfferCommunication)
    offers.kwActivateWithoutDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithoutSingleOptin;
    offers.kwActivateWithDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithSingleOptin;
    offers.protocolSentByPRM = formValues.formDataOfferCommunication.protocolo;
    offers.chargeDirection = this.checkChargingTypes(formValues.formDataOffer.offerType.id, formValues.formDataOffer.chargingType.id);
    offers.maxPrice = formValues.formDataOffer.maxPrice;
    offers.tasting = formValues.formDataOffer.tasting;
    offers.subscriptionUrl = formValues.formDataOfferCommunication.datasync;
    offers.swapPriority = formValues.formDataOffer.swapPriority;
    offers.downgradeBundleProductId = formValues.formDataOffer.downgradeBundleProductId ? formValues.formDataOffer.downgradeBundleProductId.id : null;
    offers.productCode = formValues.formDataOffer.productCodes ? formValues.formDataOffer.productCodes.join(',') : "";
    offers.bannerUrl = formValues.formDataOffer.bannerUrl;
    offers.commercialDescription = formValues.formDataOffer.commercialDescription;
    offers.resumedDescription = formValues.formDataOffer.resumedDescription;
    offers.benefits = formValues.formDataOffer.benefits;
    offers.cclasTrib = formValues.formDataOffer.cclasTrib;
    offers.cstPisCofins = formValues.formDataOffer.cstPisCofins;
    offers.cstIbsCbs = formValues.formDataOffer.cstIbsCbs;
    offers.clndop = formValues.formDataOffer.clndop;
    offers.nbs = formValues.formDataOffer.nbs;
    if(formValues.formDataOffer.issqn){
      offers.issqn = formValues.formDataOffer.issqn.split("-")[0];
    }
    offers.nationalTaxCode = formValues.formDataOffer.nationalTaxCode;
    offers.codeService = formValues.formDataOffer.codeService;
    offers.tributes = {
      cClassCode: formValues.formDataOffer.cClassCode
    };

    /*
    offers.segment = formValues.formDataOffer.segment ? formValues.formDataOffer.segment.id : null;
    offers.category = formValues.formDataOffer.category ? formValues.formDataOffer.category.id : null;
    offers.contentCategory = formValues.formDataOffer.contentCategory;
    */

    let product: any = {};

    product.name = formValues.formDataPackage.name;
    product.offer = offers;
    product.partnerId = formValues.formDataPackage.partnerId.id;
    product.realmId = Number(realmId);
    product.selectionType = formValues.formDataPackage.selectionType;
    product.shortCode = formValues.formDataPackage.shortcode;
    product.alphaTag = formValues.formDataPackage.alphaTag;
    product.svaNumber = formValues.formDataPackage.svaNumber;
    product.subscriptionUrl = formValues.formDataNotificationPackage.datasyncUrl;
    product = Object.assign(product, formValues.formDataNotificationPackage);

    console.log('finalObj:', product);

    return this.http.post(url, product, { responseType: 'text' });

  }

  public createPackageOffer(formValues, packageId, submitType=''): any {

    console.log('formValues:', formValues);

    const url = `/${this.baseURL}/package/${packageId}/offers`;

    const realmId = '426';

    let offers: any = {}

    offers = Object.assign(offers, formValues.formDataOffer);
    offers = Object.assign(offers, formValues.formDataOfferCommunication);
    offers = Object.assign(offers, formValues.formDataOfferPriceModel);

    this.removeFieldsForSubscriptionProduct(offers, 'offer');

    // offer
    offers.additionalChargeInfoISSTaxIncluded = this.additionalChargeInfoISSTaxIncluded(
      formValues.formDataOffer.TaxIncluded,
      formValues.formDataOffer.creditLoan,
      formValues.formDataOffer.CTRaccount.id,
      formValues.formDataOffer.ISSTaxIncluded
    ).code;

    offers.trustedVendors = formValues.formDataOfferCommunication.trustedVendors
    offers.authcodeChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptinViaPinCode, submitType)
    offers.doubleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithDoubleOptin, submitType)
    offers.singleChannels = this.buildArrayChannels(formValues.formDataOfferCommunication.channelsWithoutDoubleOptin, submitType)
    const usedElegibility = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.eligibilityLandline : formValues.formDataOffer.eligibility;
    offers.eligibility = this.buildArrayElegibility(usedElegibility);
    offers.isAutomaticRenew = formValues.formDataOffer.isAutomaticRenew;
    offers.suspensionPermition = formValues.formDataOffer.suspensionPermition;
    offers.isLinhaFixa = formValues.formDataOffer.isFixedLine?.id === 'yes' ? true : false;
    offers.controlMode = formValues.formDataOffer.isFixedLine?.id === 'yes' ? formValues.formDataOffer.controlMode.id.toUpperCase() : '';
    offers.sendClientIdentifier = formValues.formDataOfferCommunication.sendClientIdentifier;
    offers.chargingCodes = {
      chargeCodes: formValues.formDataOffer.eligibilityLandline ? formValues.formDataOffer.eligibilityLandline.map(data => {
        return {userPlan: data.id.split("|")[0], chargingCode: formValues.formDataOffer[data.id]}
      }): [
        {chargingCode: formValues.formDataOffer.chargingCode}
      ]
    };
    //emails PRM communication
    offers.prmCommunication = {
      subscriptionText: formValues.formDataOfferCommunication.subscriptionText,
      discountText: formValues.formDataOfferCommunication.discountText,
      loyaltyText: formValues.formDataOfferCommunication.loyaltyText,
      cancelationText: formValues.formDataOfferCommunication.cancelationText,
      preCancelationText: formValues.formDataOfferCommunication.preCancelationText,
      voucherText: formValues.formDataOfferCommunication.voucherText,
      svaLinkApp: formValues.formDataOfferCommunication.svaLinkApp,
      svaFreeLinkApp: formValues.formDataOfferCommunication.svaFreeLinkApp,
      doubleOptinLinkApp: formValues.formDataOfferCommunication.doubleOptinLinkApp,
      emailFixaFree: formValues.formDataOfferCommunication.emailFixaFree,
      cancelationWithPenaltyText: formValues.formDataOfferCommunication.cancelationWithPenaltyText,
      cancelationWithoutPenaltyText: formValues.formDataOfferCommunication.cancelationWithoutPenaltyText,
      reminderTastingTemplate: formValues.formDataOfferCommunication.reminderTastingTemplate
    }
    //emails PRM communication
    offers.isPreCancel = formValues.formDataOfferPriceModel.isPreCancel.id;
    offers.profileQuery = formValues.formDataOffer.searchProfileOnRenew;
    offers.isSendChargeFee = formValues.formDataOffer.sendChargeFee;
    offers.isNotifySPFailProcess = formValues.formDataOffer.notifySPFailProcess;
    offers.chargeDescription = formValues.formDataOffer.offerType.id === 'subscricao' ? formValues.formDataOffer.chargeDescription : formValues.formDataOffer.chargeDescriptionOneShot;
    offers.isSuspended = formValues.formDataOfferPriceModel.isSuspended;
    offers.moUrl = formValues.formDataOffer.moUrl;
    offers.msgDTOList = formValues.formDataOffer.msgDTOList;
    offers.offerName = formValues.formDataOffer.offerName;
    offers.onTopOf = formValues.formDataOffer.onTopOf;
    offers.replaceOffer = formValues.formDataOffer.replaceOffer;
    offers.notifyReplaceSubTempState = formValues.formDataOffer.notifyReplaceSubTempState;
    offers.period = formValues.formDataOffer.period.id;
    offers.periodValue = formValues.formDataOffer.periodValue;
    offers.productDescription = formValues.formDataOffer.description;
    offers.realmId = Number(realmId);
    offers.taxValue = this.additionalChargeInfoISSTaxIncluded(false, false, false, false).code;
    offers.retry = [
      {
        retries: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryTimes,
        interval: formValues.formDataOfferPriceModel.RetryNotifyBSSRetryInterval,
        msgDefKey: "ACTIVATE_BSS_PROVISIONING_MESSAGE"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyPartnerRetryInterval,
        msgDefKey: "CHARGE_DOB_NOTIF"
      },
      {
        retries: formValues.formDataOfferPriceModel.retryNotifyVendorRetryTimes,
        interval: formValues.formDataOfferPriceModel.retryNotifyVendorRetryInterval,
        msgDefKey: "VENDOR_CHARGE_DOB_NOTIF"
      }
    ]

    offers.stepDown = {
      type: formValues.formDataOfferPriceModel.stepDownOption.id,
      application: formValues.formDataOfferPriceModel.applyStepDown.id,
      automatic: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            minAmount: 1,
            entity: ""
        }
      ],
      configured: [
        {
            application: formValues.formDataOfferPriceModel.applyStepDown.id,
            steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
        }
      ],
      steps: this.buildStepDownSteps(formValues.formDataOfferPriceModel.stepsValue, formValues.formDataOfferPriceModel.stepDownPeriod.id)
    };
    offers.subPrice = Number(formValues.formDataOfferPriceModel.subPrice);
    offers.renewPrice = Number(formValues.formDataOfferPriceModel.renewPrice);
    offers.ussdNotificationUrl = formValues.formDataOffer.ussdNotificationUrl;
    offers.vivoProductId = '';
    offers.vivoServiceId = '';
    offers.keywordsDoubleOptinConfirmation = [];
    offers.keywordsDoubleOptinNegation = [];
    offers.billingCompany = formValues.formDataOfferPriceModel.companyOwner.id;
    offers.companyOwner = formValues.formDataOfferPriceModel.companyOwner.id;
    offers.priorityRenovationTopUp = formValues.formDataOffer.renewPriority.id;
    offers.multipleLicense = formValues.formDataOffer.multipleLicense;
    offers.messages = this.getMtsList('offer', formValues.formDataOfferCommunication)
    offers.kwActivateWithoutDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithoutSingleOptin;
    offers.kwActivateWithDoubleOptin = formValues.formDataOfferCommunication.kwActivateWithSingleOptin;
    offers.protocolSentByPRM = formValues.formDataOfferCommunication.protocolo;
    offers.chargeDirection = this.checkChargingTypes(formValues.formDataOffer.offerType.id, formValues.formDataOffer.chargingType.id);
    offers.maxPrice = formValues.formDataOffer.maxPrice;
    offers.tasting = formValues.formDataOffer.tasting;
    offers.cclasTrib = formValues.formDataOffer.cclasTrib;
    offers.cstPisCofins = formValues.formDataOffer.cstPisCofins;
    offers.cstIbsCbs = formValues.formDataOffer.cstIbsCbs;
    offers.clndop = formValues.formDataOffer.clndop;
    offers.nbs = formValues.formDataOffer.nbs;
    if(formValues.formDataOffer.issqn){
      offers.issqn = formValues.formDataOffer.issqn.split("-")[0];
    }
    offers.nationalTaxCode = formValues.formDataOffer.nationalTaxCode;
    offers.codeService = formValues.formDataOffer.codeService;
    offers.tributes = {
      cClassCode: formValues.formDataOffer.cClassCode
    };

    console.log('finalObj:', offers);

    return this.http.post(url, offers, { responseType: 'text' });

  }

  public createCampaign(formValues, productId, offerId): any {

    console.log('formValues:', formValues);

    const url = `/${this.baseURL}/campaign/create`;

    const realmId = '426';

    let campaign: any = {}

    campaign = Object.assign(campaign, formValues.formDataOfferPriceModel);

    let finalObj;

    if(campaign.typeKey.id === 3){
      finalObj = {
        productId: offerId,
        typeKey: "TIERED_FARE",
        name: campaign.schedulingRates[0]?.name,
        schedulingRates: campaign.schedulingRates.map((data, index) => {
          data.priority = index + 1;
          return data;
        })
      }
    }

    if(campaign.typeKey.id === 2){
      let planStr = '';
      if (campaign.discountPlan && campaign.discountPlan.length) {
        const planNames = campaign.discountPlan.map(plan => {
          if (plan.id && typeof plan.id === 'string' && plan.id.includes('|')) {
            return plan.id.split('|')[0];
          }
          return plan.id || plan.name;
        });
        planStr = [...new Set(planNames)].join(',');
      }
      let channelStr = '';
      this.buildArrayChannels(campaign.discountChannel, 'create').forEach((data, index) => {channelStr += index === 0 ? data : ',' + data})
      finalObj = {
        productId: offerId,
        name: campaign.name,
        accessTypeKey: campaign.accesstypekey, //ALL, OPTIN, RENEWAL
        typeKey: "DISCOUNT", //FREE PERIOD, TIERED FARE, DISCOUNT, TRIAL,
        discount: {
            type: campaign.discountType,
            additionalInfo: campaign.additionalInfo,
            value: campaign.discountValue,
            plan: planStr,
            channel: channelStr,
            renewApplicable: campaign.discountRenewApplicable,
            chargingCode: campaign.discountChargingCode,
            discountText: campaign.discountText,
            discountAltText: campaign.discountAltText,
            description: campaign.discountDescription
        }
      }
    }

    if(campaign.typeKey.id === 4){
      finalObj = {
        productId: offerId,
        name: campaign.name,
        typeKey: "TRIAL", //FREE PERIOD, TIERED FARE, DISCOUNT, TRIAL,
        period: campaign.period
      }
    }

    if(campaign.typeKey.id === 5){
      finalObj = {
        productId: offerId,
        name: campaign.name,
        typeKey: "FREE_PERIOD",
        period: campaign.period,
        reminders: campaign.reminders ? campaign.reminders.map(item => item.id) : [],
        tasting: true,
        tastingOffers: campaign.freeProductList ? campaign.freeProductList.map(item => String(item.id)) : []
      }
    }

    finalObj.startDate = this.datePipe.transform(campaign.startDate, "dd/MM/yyyy");
    finalObj.endDate = this.datePipe.transform(campaign.endDate, "dd/MM/yyyy");

    console.log('finalObj:', finalObj);

    return this.http.post(url, finalObj, { responseType: 'text' });

  }

  private getMtsList(type: string, formCommunication): {msgAction: string, msgValue: string}[]{
    let mts: {msgAction: string, msgValue: string}[] = []
    if(type == 'offer'){
      this.msgDTOList.mtsOffer.map(data =>{
        mts.push({msgAction: data.msgAction, msgValue: formCommunication[data.msgAction]})
      })
    } else if (type == 'product') {
      this.msgDTOList.mtsProduct.map(data =>{
        mts.push({msgAction: data.msgAction, msgValue: formCommunication[data.msgAction]})
      })
    }
    return mts
  }

  private removeFieldsForSubscriptionProduct(data: any, type: string){
    if(data && type == 'product') {
      delete data.keywordsDoubleOptinConfirmation
      delete data.keywordsDoubleOptinNegation
      delete data.kwBlock
      delete data.kwCancel
      delete data.kwHelp
      delete data.kwUnblock
      delete data.failReasonToPartner
      delete data.extensionNotify
      delete data.getUserBasicProfile
      delete data.byPassSubValidationUserBasicProfile
      delete data.isGenerateCDR
      delete data.changeMSISDN
      delete data.subsNotifyBSS
      delete data.cdProduto
      delete data.ussdUrl
      delete data.moUrl

    } else if (data && type == 'offer') {
      delete data.chargingType
      delete data.offerStatus
      delete data.offerType
      delete data.renewPriority
      delete data.supportRepeatSub
      delete data.TaxIncluded
      delete data.creditLoan
      delete data.CTRaccount
      delete data.ISSTaxIncluded
      delete data.chargeDescriptionOneShot
      delete data.kwActivateWithoutSingleOptin
      delete data.kwActivateWithSingleOptin
      delete data.stepDownOption
      delete data.stepDownPeriod
      delete data.stepsValue
      delete data.applyStepDown
      delete data.trustedVendor
      delete data.protocolo
      delete data.productTypeGlobal
      delete data.isTryAndBuy
      delete data.TryAndBuyPeriod
      delete data.TryAndBuyPeriodValue
      delete data.channelsWithoutDoubleOptin
      delete data.channelsWithDoubleOptin
      delete data.channelsWithDoubleOptinViaPinCode
      delete data.trustedVendors
      delete data.chargingCode
      this.removeFieldsMtsForSubscriptionProduct(data)
    }
  }

  private removeFieldsMtsForSubscriptionProduct(offerData: any){
    this.msgDTOList.mtsOffer.map(data =>{
      delete offerData[data.msgAction]
    })
    this.msgDTOList.mtsProduct.map(data =>{
      delete offerData[data.msgAction]
    })
  }

  public updateOfferConfigurationCommunicationMts(id, formValues): any {
    console.log('formValues:', formValues);
    const url = `/${this.baseURL}/offer/${id}/communication/mts`;
    return this.http.put(url, formValues.formData, { responseType: 'text' });
  }

  public updateProductConfigurationCommunicationMts(id, formValues): any {
    console.log('formValues:', formValues);
    const url = `/${this.baseURL}/product/${id}/configuration/communication/mts`;
    return this.http.put(url, formValues.formData, { responseType: 'text' });

  }

  public updateProductDetails(id, formValues, type = null): any {
    const url = `/${this.baseURL}/product/update/details`;
    const obj: any = {
      id,
      name: formValues.productName.value,
      description: formValues.description.value,
      idVivo: formValues.idVivo.value,
      contentAgentName: formValues.contentAgentName.value,
      contentAgentId: formValues.contentAgentId.value,
      isMigration: formValues.isMigration.value,
      uniqueCPF: formValues.uniqueCPF.value,
      partnerIdVivo: type == "BUNDLE" ? formValues.partnerId?.value?.idVivo : formValues.partner?.value?.idVivo
    };
    
    if (type !== "BUNDLE"){
      const segmentValue = formValues.segment.value;
      const segmentName = typeof segmentValue === 'object' ? (segmentValue?.name || null) : segmentValue;
      obj.segment = segmentName;
    }


    if(type == "BUNDLE"){
      obj.isAppVivoManaged = formValues.isAppVivoManaged.value;
      obj.isRecoveryLink = formValues.isRecoveryLink.value;
      obj.isBindingLink = formValues.isBindingLink.value;
      obj.bindingProductId = formValues.bindingProductId.value.id;
    }
    return this.http.put(url, obj, { responseType: 'text' });

  }

  public getSearchChannels(): Observable<any> {
    const url = `/${this.baseURL}/product/search/channels`;
    return this.http.get(url);
  }

  public getSearchNotTasting(productId): Observable<any> {
    const url = `/${this.baseURL}/offer/searchNotTasting?productId=${productId}`;
    return this.http.get(url);
  }

  public getSearchTasting(productId): Observable<any> {
    const url = `/${this.baseURL}/offer/tastingOffers?productId=${productId}`;
    return this.http.get(url);
  }

  public getTrustedVendorList(): Observable<any> {
    const url = `/${this.baseURL}/partner/trusted-vendors`;
    return this.http.get(url);
  }

  public editProdConfNotif(formData, configData){
    const url = `/${this.baseURL}/product/configuration/notification`;
    let data = {
        "getUserBasicProfile": formData.getUserBasicProfile,
        "subscriptionUrl": formData.subscriptionNotificationUrl,
        "changeMsisdnUrl": formData.changeMsisdnUrl,
        "moUrl": formData.moUrl,
        "isGenerateCDR": configData.isGenerateCDR,
        "productDefOp": configData.productDefOp,
        "realmId": configData.realmId,
        "bssNotificationCdProduto": formData.bssNotificationCdProduto,
        "bssNotificationCodigoFuncionalidades": configData.bssNotificationCodigoFuncionalidades,
        "bssNotificationNomeServico": configData.bssNotificationNomeServico,
        "bssNotificationSigaFluxo": configData.bssNotificationSigaFluxo,
        "isByPassSubValidationUserBasicProfile": formData.isByPassSubValidationUserBasicProfile,
        "isExtensionNotify": formData.isExtensionNotify,
        "isFailReasonToPartner": formData.isFailReasonToPartner,
        "isSubsNotifyBss": formData.isSubsNotifyBss,
        "ussdUrl": formData.ussdUrl
    };
    return this.http.post(url, data, { responseType: 'text' });
  }

  public editProdOfferNotif(formData, configData){
    const url = `/${this.baseURL}/offer/update/notification`;
    let data = {
        "isSupportRetryLogic": formData.isSupportRetryLogic,
        "partnerRetryTime": formData.partnerRetryTime,
        "partnerRetryInterval": formData.partnerRetryInterval,
        "vendorRetryTime": formData.vendorRetryTime,
        "vendorRetryInterval": formData.vendorRetryInterval,
        "bssRetryTime": formData.bssRetryTime,
        "bssRetryInterval": formData.bssRetryInterval,
        "isSendChargeFee": formData.isSendChargeFee,
        "isNotifySPFailProcess": formData.isNotifySPFailProcess,
        "superVendor": configData.superVendor,
        "vendorService": configData.vendorService,
        "offerId": configData.offerId,
        "subscriptionUrl": formData.subscriptionUrl,
        "sendClientIdentifier": formData.sendClientIdentifier,
        "chargeDescription": formData.chargeDescription,
        "cancelBypass": formData.cancelBypass,
        "blacklistBypass": formData.blacklistBypass
    };
    return this.http.put(url, data, { responseType: 'text' });
  }

  public editOfferCampaignTiered(formData){
    const url = `/${this.baseURL}/campaign/update/tiered`;
    return this.http.put(url, formData, { responseType: 'text' });
  }

  public editProdOfferCampaign(formData: any, campaignId: number){
    const url = `/${this.baseURL}/campaign/${campaignId}`;
    return this.http.put(url, formData, { responseType: 'text' });
  }

  public editOfferDetails(formData, configData, isOneshot?: boolean, offerId = 0, formControl:any = null, landlineService=false){

    console.log(formData, formControl)

    const url = `/${this.baseURL}/offer/update/details`;

    if(formControl) {
  
      formData.id = offerId;
      if (isOneshot !== true) {
        formData.additionalChargeInfo = {
          taxIncluded: formData.TaxIncluded,
          creditLoan: formData.creditLoan,
          ctrAccount: formData.CTRaccount.id,
          issTaxIncluded: formData.ISSTaxIncluded
        };
        formData.howToUse = formControl.howToUseStep.value.map(data => data.howToUseStepItem);
        formData.category = formData?.category ? formData.category : formControl.category.value;
        formData.onTopOf = formControl.onTopOf.value;
        formData.downgradeBundleProductId = formControl.downgradeBundleProductId?.value?.id;
        if(formControl.preReservation.value){
          formData.preReservation = formControl.preReservation.value.id;
        }
        if(formData.isStepDown){
          if(formData.stepDownOption.id === 'STEP_DOWN_AUTOMATIC') {
            formData.stepDown = {
              type: formData.stepDownOption.id,
              application: formData.applyStepDown.id
            };
          }
          if(formData.stepDownOption.id === 'STEP_DOWN') {
            formData.stepDown = {
              type: formData.stepDownOption.id,
              application: formData.applyStepDown.id,
              steps: this.buildStepDownSteps(formData.stepsValue, formData.stepDownPeriod.id)
            };
          }
        }
      }
      if(formData.needSubscribe){
        formData.authcodeChannels = this.buildArrayChannels(formData.channelsWithDoubleOptinViaPinCode, 'create');
        formData.doubleChannels = this.buildArrayChannels(formData.channelsWithDoubleOptin, 'create');
        formData.singleChannels = this.buildArrayChannels(formData.channelsWithoutDoubleOptin, 'create');
      }
      if(formData.eligibility && formData.eligibility.length > 0){
        
        formData.eligibility = formData.eligibility.map(data => {
          return data.split("|")[0];
        }).filter((item, index) => formData.eligibility.indexOf(item) === index); 
        
        //formData.eligibility = this.prepareDataEligibility(formData.eligibility, true);
      }
      if(formData.eligibilityLandline && formData.eligibilityLandline.length > 0){
        
        formData.eligibility = formData.eligibilityLandline.map(data => {
          return data.split("|")[0];
        }).filter((item, index) => formData.eligibilityLandline.indexOf(item) === index); 
        
        //formData.eligibility = this.prepareDataEligibility(formData.eligibility, true);
      }

      if (formData.regretPeriod){
        formData.regretPeriod = Number(formData.regretPeriod);
      }
      if(formData.planChangeOfferId == 0){
        formData.planChangeOfferId = '';
      }
    }
    
    return this.http.post(url, formData);
  }

  public addOfferEligibility(arrayEligibility, configData) {
    const url = `/${this.baseURL}/offer/` + configData.id + '/addEligibility';
    return this.http.put(url, arrayEligibility);
  }

  public removeOfferEligibility(arrayEligibility, configData){
    console.log(arrayEligibility);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: arrayEligibility
    };
    const url = `/${this.baseURL}/offer/` + configData.id + '/removeEligibility';
    return this.http.delete(url, options);
  }

  public getOfferEligibility(id: string){
    const url = `/${this.baseURL}/offer/` + id + '/listEligibility';
    return this.http.get(url);
  }

  public getPreReservation(){
    const url = `/${this.baseURL}/pre-reservation`;
    return this.http.get(url);
  }

  /**
   * @description Method to get offer states
   * @returns Observable<{id: number, name: string}[]>
   */
  public getOfferStates(): Observable<{id: number, name: string}[]> {
    const url = `/${this.baseURL}/offer/status`;
    return this.http.get<{id: number, name: string}[]>(url).pipe(
      map((response: any) => {
        response = response.map((state, index) => ({
          label: state,
          value: state
        }));
        return response;
      })
    );
  }

  /**
   * @param offerId number
   * @param state string
   * @description Method to post offer state
   * @returns Observable<any>
   */
  public postOfferState(offerId: number, state: string): Observable<any> {
    if(!offerId)
      return throwError('Missing offerId parameter when postOfferStates was called');
    const url = `/${this.baseURL}/offer/${offerId}/status`;
    return this.http.post<any>(url, {status: state});
  }

  /**
   * @param productId number
   * @param KeywordsData ProductKeywords
   * @description Method to edit product keywords
   * @returns Observable<any>
   */
  public putProductKeywords(productId: number, KeywordsData: ProductKeywords): Observable<any> {
    if(!productId)
      return throwError('Missing productId parameter when putProductKeywords was called');
    if(!KeywordsData)
      return throwError('Missing KeywordsData parameter when putProductKeywords was called');
    const url = `/${this.baseURL}/product/${productId}/configuration/communication/keyword`;
    return this.http.put<any>(url, KeywordsData);
  }

  /**
 * @param offerId number
 * @description Method to edit offers channels
 * @returns Observable<any>
 */
  public putOfferChannels(offerId: number, channelsData: OfferChannels): Observable<any> {
    if(!offerId)
      return throwError('Missing offerId parameter when putOfferChannels was called');
    if(!channelsData)
      return throwError('Missing channelsData parameter when putOfferChannels was called');

    const url = `/${this.baseURL}/offer/${offerId}/communication/channel`;
    return this.http.put<any>(url, channelsData);
  }

  public updateOfferTributes(offerId: number, data: object): Observable<any> {
    if(!offerId)
      return throwError('Missing offerId parameter when updateOfferTributes was called');
    const url = `/${this.baseURL}/offer/${offerId}/tributes`;
    return this.http.put<any>(url, data);
  }

  public updateOfferLoyalty(offerId: number, data: object): Observable<any> {
    if(!offerId)
      return throwError('Missing offerId parameter when updateOfferLoyalty was called');
    const url = `/${this.baseURL}/offer/${offerId}/loyalty`;
    return this.http.put<any>(url, data);
  }

  public getCityInfo(): Observable<any> {
    const url = `/${this.baseURL}/city-tax-info`;
    return this.http.get<any>(url);
  }

  /**
 * @param taxType tax name
 * @description Method to get tax rates list
 * @returns Observable<any>
 */
  public getTaxRates(taxType: string): Observable<any> {
    let myParams = new HttpParams();
    if (taxType) {
      myParams = myParams.append('taxType', taxType.toUpperCase())
    }
    const url = `/${this.baseURL}/tax-rates`;
    return this.http.get<any>(url, {params: myParams});
  }

  /**
 * @param packageId package id
 * @description Method to edit package detail data
 * @returns Observable<any>
 */
  public editPackageDetail(formData: any, packageId: number, packageData: any){
    formData.id = packageData.id;
    formData.idVivo = formData.idVivo || packageData.idVivo;
    formData.partnerIdVivo = packageData.partnerIdVivo;
    formData.serviceId = packageData.serviceId;
    const productCodes = formData.productCodes;
    formData.productCodes = productCodes ? productCodes.join(',') : "";
    const url = `/${this.baseURL}/package/${packageId}`;
    return this.http.put(url, formData, { responseType: 'text' });
  }

  public getPaymentTypes(): Observable<any> {
    const url = `/${this.baseURL}/offer/listAllPaymentTypes`;
    return this.http.get(url);
  }

  public getListTastingOffers(productId: number): Observable<any> {
    const url = `/${this.baseURL}/offer/tastingOffers?productId=${productId}`;
    return this.http.get<any>(url);
  }

}
